import React from "react";
import DummyRound from "./DummyRound";

const RoundCreator = ({ selectedList, roundsList }) => {
  return (
    <>
      {selectedList?.data?.leageData &&
        selectedList?.data?.leageData[0].rounds?.length > 0 &&
        selectedList?.data?.leageData[0].rounds?.length == 1 && (
          <>
            {roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider2Padding={0.15}
                          divider3Style="450%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={16}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="850%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={32}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={16}
                          // divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={8}
                          // divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="625px"
                          divider2Style="605px"
                          // divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={64}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={32}
                          divider2Height="177px"
                          divider2Style="156px"
                          divider3Style="245%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={16}
                          divider2Height="353px"
                          divider2Style="332px"
                          divider3Style="450%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="705px"
                          divider2Style="685px"
                          divider2Padding={0.15}
                          divider3Style="905%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1410px"
                          divider2Style="1387px"
                          divider2Padding={0.15}
                          divider3Style="1787%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2815px"
                          divider2Style="2800px"
                          divider2Padding={0.15}
                          divider3Style="3580%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 8
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 8 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                          divider2Padding={0.15}
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 4
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 4 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 2
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 2 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 1 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

      {selectedList?.data?.leageData &&
        selectedList?.data?.leageData[0].rounds?.length > 0 &&
        selectedList?.data?.leageData[0].rounds?.length == 2 && (
          <>
            {roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 2 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="177px"
                          divider2Style="156px"
                          divider3Style="245%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="353px"
                          divider2Style="332px"
                          divider3Style="450%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 2 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Height="177px"
                          divider2Style="156px"
                          divider3Style="245%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="353px"
                          divider2Style="332px"
                          divider3Style="450%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="705px"
                          divider2Style="685px"
                          divider3Style="905%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 2 && (
                      <>
                        <DummyRound
                          rounds={16}
                          divider2Height="177px"
                          divider2Style="156px"
                          divider3Style="245%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="353px"
                          divider2Style="332px"
                          divider3Style="450%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="705px"
                          divider2Style="685px"
                          divider3Style="905%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1410px"
                          divider2Style="1387px"
                          divider2Padding={0.15}
                          divider3Style="1787%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 2 && (
                      <>
                        <DummyRound
                          rounds={32}
                          divider2Height="177px"
                          divider2Style="156px"
                          divider3Style="245%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={16}
                          divider2Height="353px"
                          divider2Style="332px"
                          divider3Style="450%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="705px"
                          divider2Style="685px"
                          divider2Padding={0.15}
                          divider3Style="905%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1410px"
                          divider2Style="1387px"
                          divider2Padding={0.15}
                          divider3Style="1787%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2820px"
                          divider2Style="2800px"
                          divider2Padding={0.15}
                          divider3Style="3580%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 8
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 8 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 2 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="177px"
                          divider2Style="156px"
                          divider3Style="245%"
                          divider2Padding={0.15}
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds === 4
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 4 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 2 && (
                      <>
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

      {selectedList?.data?.leageData &&
        selectedList?.data?.leageData[0].rounds?.length > 0 &&
        selectedList?.data?.leageData[0].rounds?.length == 3 && (
          <>
            {roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 3 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="352px"
                          divider2Style="332px"
                          divider3Style="462%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 3 && (
                      <>
                        <DummyRound
                          rounds={4}
                          // divider2Padding={0.8}
                          divider2Height="353px"
                          divider2Style="333px"
                          divider3Style="462%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="705px"
                          divider2Style="685px"
                          // divider2Padding={0.8}
                          divider3Style="900%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 3 && (
                      <>
                        <DummyRound
                          rounds={8}
                          // divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="625px"
                          divider2Style="605px"
                          // divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 3 && (
                      <>
                        <DummyRound
                          rounds={16}
                          divider2Height="353px"
                          divider2Style="333px"
                          divider3Style="465%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="705px"
                          divider2Style="685px"
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1410px"
                          divider2Style="1390px"
                          divider3Style="1780%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2815px"
                          divider2Style="2795px"
                          divider2Padding={0.15}
                          divider3Style="3545%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds === 8
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 8 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 3 && (
                      <>
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

      {selectedList?.data?.leageData &&
        selectedList?.data?.leageData[0].rounds?.length > 0 &&
        selectedList?.data?.leageData[0].rounds?.length == 4 && (
          <>
            {roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 4 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="705px"
                          divider2Style="685px"
                          // divider2Padding={0.15}
                          divider3Style="900%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 4 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 4 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

      {selectedList?.data?.leageData &&
        selectedList?.data?.leageData[0].rounds?.length > 0 &&
        selectedList?.data?.leageData[0].rounds?.length == 5 && (
          <>
            {roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 5 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 5 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

      {selectedList?.data?.leageData &&
        selectedList?.data?.leageData[0].rounds?.length > 0 &&
        selectedList?.data?.leageData[0].rounds?.length == 6 && (
          <>
            {roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedList?.data?.leageData[0]?.rounds?.length == 6 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="2820px"
                          divider2Style="2800px"
                          divider2Padding={0.15}
                          divider3Style="3545%"
                        />
                        <DummyRound rounds={1} virtual />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

    </>
  );
};

export default RoundCreator;
